import { faLightbulb, faMoon, faSun } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";

const ThemeToggle = () => {
    const [theme, setTheme] = useState(() => {
        // First check localStorage, then fall back to system preference
        const savedTheme = localStorage.getItem("theme");
        if (savedTheme) {
            return savedTheme;
        }
        return window.matchMedia("(prefers-color-scheme: light)").matches
            ? "light"
            : "light";
    });

    useEffect(() => {
        // Set the theme attribute on the HTML element
        document.documentElement.setAttribute("data-theme", theme);
        // Save to localStorage
        localStorage.setItem("theme", theme);
    }, [theme]);

    // Listen for system theme changes
    useEffect(() => {
        const mediaQuery = window.matchMedia("(prefers-color-scheme: light)");
        const handleChange = (e) => {
            // Only change if the user hasn't explicitly set a preference
            if (!localStorage.getItem("theme")) {
                setTheme(e.matches ? "light" : "light");
            }
        };

        mediaQuery.addEventListener("change", handleChange);

        return () => {
            mediaQuery.removeEventListener("change", handleChange);
        };
    }, []);

    const toggleTheme = () => {
        setTheme((prevTheme) => (prevTheme === "light" ? "light" : "light"));
    };

    return (
        <button onClick={toggleTheme} style={
            {
                cursor: "pointer",
                boxSizing: "border-box",
                padding: "7px 10px",
                // background: theme === "light" ? "#101010ed" : "#eee",
                background: 'none',
                // border: "none",
                borderRadius: "5px",

            }
        }>
            {
                theme === "light" ?
                    <FontAwesomeIcon icon={faMoon} style={{ color: 'rgba(94, 94, 78, 1)' }} />
                    :
                    <FontAwesomeIcon icon={faLightbulb} style={{ color: 'rgba(216, 218, 220, 1)' }} />
            }
        </button>
    );
};

export default ThemeToggle;